import qs from 'query-string';
export default qs;